//         __                          __  ______     _      __  ________              __
//   ___  / /__  ____ ___  ___  ____  / /_/ ____/  __(_)____/ /_/ ____/ /_  ___  _____/ /__
//  / _ \/ / _ \/ __ `__ \/ _ \/ __ \/ __/ __/ | |/_/ / ___/ __/ /   / __ \/ _ \/ ___/ //_/
// /  __/ /  __/ / / / / /  __/ / / / /_/ /____>  </ (__  ) /_/ /___/ / / /  __/ /__/ ,<
// \___/_/\___/_/ /_/ /_/\___/_/ /_/\__/_____/_/|_/_/____/\__/\____/_/ /_/\___/\___/_/|_|

/* global siteVars */

// import { app } from './app';
// import { setupProjectParallax } from './parallax';
// import 'imagesloaded';
// import { scrollToHref } from '../util/scrolltohref.js';
// import anime from 'animejs/lib/anime.es.js';
import Splitting from 'splitting';
import { loadGoogleMaps } from './maps';
import { splitInner } from './splitting-setup';
import { setupObserverGravityForms } from './observer-setup';

const elementExistCheck = () => {
  console.log('{ elementExistCheck }');

  const barbaContainer = $('.barba-container');

  // ----------------------------------------------------------------------------
  //
  // Tablet & Desktop image sizes
  //
  // ----------------------------------------------------------------------------
  if (!barbaContainer.hasClass('mobile')) {
    console.log('Updating data-sizes');

    $('.bg__white .slide__image')
      .attr('data-sizes', '85vw')
      .attr('sizes', '85vw');

    $(
      '.two-columns .col__two-third .slide__image, .col__two-third .image-wrap__image'
    )
      .attr('data-sizes', '66vw')
      .attr('sizes', '66vw');
    $(
      '.two-columns .col__one-third .slide__image, .col__one-third .image-wrap__image'
    )
      .attr('data-sizes', '33vw')
      .attr('sizes', '33vw');

    $('.copy-image-feature__image, .card-grid--third img')
      .attr('data-sizes', '33vw')
      .attr('sizes', '33vw');

    $('.card-grid--our-work .article-post__image')
      .attr('data-sizes', '34vw')
      .attr('sizes', '34vw');

    $('.post .article-post__image')
      .attr('data-sizes', '37vw')
      .attr('sizes', '37vw');

    $('.card-grid--half img')
      .attr('data-sizes', '50vw')
      .attr('sizes', '50vw');
  }

  // ----------------------------------------------------------------------------
  //
  // Locations Page
  //
  // ----------------------------------------------------------------------------
  // Check if on home page
  if (barbaContainer.hasClass('page-template-template-locations')) {
    console.log('{ page-template-template-locations }');

    loadGoogleMaps();

    // ----------------------------------------------------------------------------
    // Ajax request GravityForms - contact form
    // ----------------------------------------------------------------------------
    $.ajax({
      url: siteVars.ajaxPath,
      type: 'get',
      data: {
        form_id: siteVars.gform_id,
        action: 'ajax_get_gform'
      },
      success: function(result) {
        // inject result markup in-to placeholder
        $('.header-page__form')
          .html(result)
          .addClass('show');
        // apply splitting
        Splitting({
          /* target: String selector, Element, Array of Elements, or NodeList */
          target: '.gfield [data-splitting]',
          /* by: String of the plugin name */
          by: 'lines'
        });
        splitInner($('.gfield_label .word'));
        // fire observer checking code for reveal animation
        setupObserverGravityForms();
      }
    });
  }

  // ----------------------------------------------------------------------------
  //
  // Filtering
  //
  // ----------------------------------------------------------------------------
  if ($('.article-filter')) {
    $(document).on('click', '.js-filter', function(e) {
      e.preventDefault();

      const t = $(this);

      // disable double selection
      if (t.hasClass('active')) {
        return;
      }

      // remove current active filter link
      $('.js-filter').removeClass('active');

      // update current filter link
      t.addClass('active');

      // get clicked filter
      const filter = t.attr('data-filter');
      const articles = $('.js-filter-article');

      if ('js-filter_all' === filter) {
        // reveal all
        articles
          .addClass('hidden')
          .hide(0)
          .removeClass('hidden zoom-in')
          .show(0)
          .addClass('zoom-in');
      } else {
        // hide all
        articles
          .addClass('hidden')
          .hide(0)
          .removeClass('zoom-in');
        // show filtered
        articles
          .filter('.' + filter)
          .removeClass('hidden')
          .show(0)
          .addClass('zoom-in');
      }
    });
  } // END if

  // ----------------------------------------------------------------------------
  //
  // Homepage Header Title Animated Words
  //
  // ----------------------------------------------------------------------------
  if (barbaContainer.hasClass('page-template-template-home')) {

    const word_insert1 = $('.js-word-insert1');
    const word_insert2 = $('.js-word-insert2');

    const word_set1 = $('.js-word-set1').children();
    const word_set2 = $('.js-word-set2').children();

    // console.groupCollapsed('{ homepage titles }');
    // console.log('word_insert1: %o', word_insert1);
    // console.log('word_insert2: %o', word_insert2);
    // console.log('word_set1: %o', word_set1);
    // console.log('word_set2: %o', word_set2);
    // console.groupEnd();

    const CallbackTimer = class {
      constructor(target, els) {
        this.timing = false;
        this.timerIndex = null;
        this.count = 1;

        this.target = target;
        this.els = els;
        this.els_len = els.length;

        if ( this.els_len === 1 ) {
          this.count = 0;
        }
      }

      start() {

        if ( 0 === this.target.length || 0 === this.els_len ) {
          return;
        }

        this.timing = true;

        this.timerIndex = setTimeout(() => {
          // animate hide word
          $(this.target)
            .addClass('show-off')
            .removeClass('show-on');

          // use timer to delay time taken to hide word (CSS animation)
          setTimeout(() => {

            // console.log( 'this.count: %o', this.count );
            // console.log( 'this.els_len: %o', this.els_len );
            // console.log( '$(this.els[this.count]): %o', $(this.els[this.count]) );
            // inject new word after delay
            this.target.html( $(this.els[this.count]).clone(true) );

            const target = $(this.target);

            // reset animation
            target.offset();

            // remove hide text class
            target
              .removeClass('show-off')
              .addClass('show-on');

            // strip .show class from wire-text
            target
              .find('.wire-text')
              .removeClass('show')
              .addClass('show');

            // increase counter
            this.count++;

            // check not reached max, reset if so
            if (this.count === this.els_len) {
              this.count = 0;
            }

            // repeat
            this.start();

          }, 500);

        }, 3000);

      }

      stop() {
        clearTimeout(this.timerIndex);
        this.timing = false;

        console.log('Stopped: this.els: %o', this.els);
      }
    };

    // Initialise
    const myTimer1 = new CallbackTimer(word_insert1, word_set1);
    const myTimer2 = new CallbackTimer(word_insert2, word_set2);

    // console.log('myTimer1: %o', myTimer1);
    // console.log('myTimer2: %o', myTimer2);

    // Start
    myTimer1.start();

    // Delayed start for second word
    setTimeout(() => {
      myTimer2.start();
    }, 1000);
  }
};

export { elementExistCheck };



// WEBPACK FOOTER //
// ./scripts/modules/element-exist-check.js